import axios from "axios";
import { getToken, getRefreshToken, setAccessToken, clearToken } from "./authToken";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Attach the JWT as a Bearer header when present (required for the native mobile app,
// where cross-origin cookies are not reliably persisted). Cookies still work on web.
api.interceptors.request.use((config) => {
  const t = getToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

// Silent refresh: on a 401, try once to mint a new access token from the stored refresh
// token, then retry the original request. If refresh fails, clear the session.
let refreshing = null;
api.interceptors.response.use(
  (res) => res,
  async (err) => {
    const orig = err.config;
    const status = err?.response?.status;
    const isRefreshCall = orig?.url?.includes("/auth/refresh");
    if (status === 401 && orig && !orig._retry && !isRefreshCall && getRefreshToken()) {
      orig._retry = true;
      try {
        refreshing = refreshing || api.post("/auth/refresh", { refresh_token: getRefreshToken() });
        const { data } = await refreshing;
        refreshing = null;
        setAccessToken(data.access_token);
        orig.headers = orig.headers || {};
        orig.headers.Authorization = `Bearer ${data.access_token}`;
        return api(orig);
      } catch (e) {
        refreshing = null;
        clearToken();
        return Promise.reject(e);
      }
    }
    if (status === 401 && !isRefreshCall) clearToken();
    return Promise.reject(err);
  }
);

export function apiErr(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || "Something went wrong.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return String(d);
}
